import request from '@/utils/request';
import { stringify } from 'qs';

//================首页=====================

//获取导航
export async function incomes(): Promise<any> {
  return request('/api/v1/user/incomes');
}
